<template>
    <v-dialog v-model="getModalCadastroCargo" max-width="500px" transition="dialog-transition">
        <v-card outlined>
            <v-card-title>Cadastro de Cargo</v-card-title>
            <v-form class="px-3" ref="form">
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field dense outlined v-model="getCargo.nome" label="Nome" class="ml-2 mr-2" :rules="rules.nome"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field dense outlined v-model="getCargo.descricao" label="Descrição"
                                class="ml-2 mr-2" :rules="rules.descricao"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-select dense outlined :items="getPerfis" v-model="getCargo.perfil_id" label="Perfil" item-value="id"
                                item-text="perfil" class="ml-2 mr-2" :rules="rules.perfil"></v-select>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined color="default" @click="setModalCadastroCargo(false)">Voltar</v-btn>
                    <v-btn outlined color="error" @click="setModalExcluirCargo(true)" v-if="getCargo.id && $helper.verificaPermissao('excluir-cargo')">Excluir</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="success" @click="salvar" v-if="$helper.verificaPermissao('cadastrar-cargo') || $helper.verificaPermissao('atualizar-cargo')">Salvar</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <ModalExcluir />
    </v-dialog>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'
    import ModalExcluir from '@/pages/cargo/ModalExcluir'
    export default {
        components: {
            ModalExcluir
        },
        data(){
            return { 
                rules: {
                    nome: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    descricao: [
                        v => !!v || 'Campo obrigatório.' 
                    ],
                    perfil: [
                        v => !!v || 'Selecione um perfil.'
                    ],
                }
            }
        },
        computed: {
            ...mapGetters([
                'getCargo',
                'getModalCadastroCargo',
                'getPerfis'
            ])
        },
        methods: {
            ...mapActions([
                'atualizarCargo',
                'salvarCargo',
                'excluirCargo',
                'setModalCadastroCargo',
                'listarPerfil',
                'setModalExcluirCargo'
            ]),
            salvar() {
                if(this.$refs.form.validate()){
                    if (this.getCargo.id) {
                        this.atualizarCargo(this.getCargo)
                    } else {
                        this.salvarCargo(this.getCargo)
                    }
                }
                
            }
        },
        created(){
            this.listarPerfil()
        }
    }
</script>